import {
  useCrearRequerimientoEvolucion,
  useEditarRequerimientoEvolucion,
  useEliminarRequerimientoEvolucion,
  useListarObjetos,
  useListarRequerimientosEvolucion,
} from "../../../../Hooks/Admin";
import { CustomForm } from "../../../../Components/Admin/CustomForm";
import { CustomTable } from "../../../../Components/Admin/CustomTable";
import {
  camposFormulario,
  columns,
  formatData,
  camposFilter,
} from "./camposFormulario";
import { useEffect, useState } from "react";

export const RequerimientoEvolucionForm = () => {
  const [campos, setCampos] = useState();
  const [objetos, setObjetos] = useState(null);

  const querySelectObjetos = useListarObjetos();

  const initialValues = {
    obje_id: 1,
  };

  useEffect(() => {
    if (querySelectObjetos.isSuccess) {
      setObjetos(querySelectObjetos.data);
    }
  }, [querySelectObjetos.isSuccess]);

  useEffect(() => {
    setCampos(camposFormulario(objetos));
  }, [objetos]);

  return (
    <>
      {campos && (
        <CustomForm
          camposFormulario={campos}
          querySubmit={useCrearRequerimientoEvolucion}
          initialValues={initialValues}
        />
      )}
    </>
  );
};

export const RequerimientoEvolucionEditar = () => {
  const [campos, setCampos] = useState();
  const [objetos, setObjetos] = useState(null);
  const querySelectObjetos = useListarObjetos();

  useEffect(() => {
    if (querySelectObjetos.isSuccess) {
      setObjetos(querySelectObjetos.data);
    }
  }, [querySelectObjetos.isSuccess]);

  useEffect(() => {
    setCampos(camposFormulario(objetos));
  }, [objetos]);

  return (
    <CustomTable
      camposFilter={camposFilter}
      camposFormularioModal={campos}
      queryListar={useListarRequerimientosEvolucion}
      queryEditar={useEditarRequerimientoEvolucion}
      formatData={formatData}
      columns={columns}
      editable={true}
      camposAgregar={camposFormulario(objetos)}
      queryCrear={useCrearRequerimientoEvolucion}
      tituloEditar={"Editar Requimimiento Evolución"}
      canDelete={true}
      queryBorrarFila={useEliminarRequerimientoEvolucion}
    />
  );
};
